import axios from 'axios';
import { cancelPreviewSliceAction } from './CancelPreviewSlice';

const getCancelPreviewData = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/subscription/web/cancel/preview`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(cancelPreviewSliceAction.cancelPreviewSuccess(result.data));
    } catch (e) {
      dispatch(cancelPreviewSliceAction.cancelPreviewFailure(e.response?.data ?? e.message));
    }
  };
};

export default getCancelPreviewData;